// Merchant-level style choices for every AI agent, saved on the profile as
// agent_tone, agent_formality_level and agent_enthusiasm_level.
export const DEFAULT_TONE = 'warm'
export const DEFAULT_FORMALITY = 'casual'
export const DEFAULT_ENTHUSIASM = 'high'

export const TONE_OPTIONS = [
  { name: 'Warm', value: 'warm' },
  { name: 'Playful', value: 'playful' },
  { name: 'Professional', value: 'professional' },
  { name: 'Friendly', value: 'friendly' },
  { name: 'Casual', value: 'casual' }
]

export const FORMALITY_OPTIONS = [
  { name: 'Casual', value: 'casual' },
  { name: 'Semi-formal', value: 'semi-formal' },
  { name: 'Formal', value: 'formal' }
]

export const ENTHUSIASM_OPTIONS = [
  { name: 'Low', value: 'low' },
  { name: 'Medium', value: 'medium' },
  { name: 'High', value: 'high' }
]
